









import {defineComponent} from "@vue/composition-api";

export default defineComponent({
    name: "InnerLoader",
    props: {
        text: {
            type: String,
            required: false,
            default: ""
        },
        iconClass: {
            type: String,
            required: false,
            default: "vuw-mb-4 vuw-text-l"
        },
        loaderClass: {
            type: String,
            required: false,
            default: ""
        }
    },
})
